import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  Avatar,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import {
  useDeleteProductMutation,
  useGetCategoryQuery,
  useGetMainItemQuery,
  useDeleteMainItemMutation,
  useGetUserInfoOnyQuery,
  useGetProductWithStoreQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IMainItem,
  IVariantView,
  IUserAdmin,
} from "../../../Api/Interface/api.interface";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopupTenant from "../Edit/index";
import NewPopUpProduct from "../../Product/Edit/index";
import { useNotifier } from "../../../Core/Notifier";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { IoIosImages } from "react-icons/io";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import Pagination from "../../../Components/Pagination";
import useIsMobile from "../../../Core/hook/useIsMobile";
import DoneIcon from "@mui/icons-material/Done";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import dayjs, { Dayjs } from "dayjs";
import ReplaceImage from "../../../Images/repImg.png";

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [selectCustomer, setSelectCustomer] = useState<IMainItem | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<IVariantView | null>(
    null
  );
  const [openDialogProduct, setOpenDialogProduct] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IVariantView | null>(
    null
  );
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [openDialogProductMI, setOpenDialogProductMI] = useState(false);
  const [openDeleteProductMI, setOpenDeleteProductMI] = useState(false);
  const [productToDeleteMI, setProductToDeleteMI] = useState<IMainItem | null>(
    null
  );
  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  const { data, isLoading, isError } = useGetMainItemQuery({
    searchText: "",
    id: String(ProductId),
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const {
    data: productData,
    isLoading: productIsLoading,
    isError: productIsError,
    refetch,
  } = useGetProductWithStoreQuery({
    searchText: searchQuery,
    id: null,
    variantBrandId: null,
    categoryId: null,
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
    mainItemId: String(ProductId),
  });

  const { data: productCountData, isLoading: productCountIsLoading } =
    useGetProductWithStoreQuery({
      searchText: "",
      id: null,
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
      mainItemId: String(ProductId),
    });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IMainItem;
    }
    return null;
  }, [data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryList]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const handleOpenEditTenant = () => {
    setSelectCustomer(product);
    setOpenDialog(true);
  };

  const handleCloseEditTenant = () => {
    setSelectCustomer(null);
    setOpenDialog(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOpenDialog = (product: IVariantView) => {
    setSelectedProduct(product);
    setOpenDialogProduct(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialogProduct(false);
  };

  const handleOpenDeletePopup = (product: IVariantView) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleOpenDeletePopupMI = (product: IMainItem) => {
    setProductToDeleteMI(product);
    setOpenDeleteProductMI(true);
  };

  const handleCloseDeletePopupMI = () => {
    setProductToDeleteMI(null);
    setOpenDeleteProductMI(false);
  };

  const handleAddProductClick = () => {
    navigate(`/product/create/${product?.id}`);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const [deleteCategory] = useDeleteProductMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const [deleteCategoryMI] = useDeleteMainItemMutation();
  const handleDeleteMI = async (id: string) => {
    try {
      const response = await deleteCategoryMI(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProductMI(false);
        navigate(`/main/item/list`);
      } else {
        setAlertMessage(response.message);
        setDeleteAlert(true);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Product");
    }
  };

  const coursings: IVariantView[] = Array.isArray(productData?.data)
    ? (productData?.data as IVariantView[])
    : [];

  const countVariant: IVariantView[] = Array.isArray(productCountData?.data)
    ? (productCountData?.data as IVariantView[])
    : [];

  const CompactStatusCard = ({
    label,
    status,
  }: {
    label: string;
    status: boolean;
  }) => {
    const iconColor = status ? "#4caf50" : "#f44336";
    const iconBg = status ? "#e8f5e9" : "#ffebee";
    const Icon = status ? CheckCircleIcon : CancelIcon;

    return (
      <Card className={classes.variantviewfristcard}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: iconBg, color: iconColor }}>
            <Icon />
          </Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  const CompactStatusCardIcon = ({
    label,
    status,
  }: {
    label: string;
    status: boolean;
  }) => {
    const iconColor = status ? "#4caf50" : "#f44336";
    const iconBg = status ? "#e8f5e9" : "#ffebee";
    const Icon = status ? ProductionQuantityLimitsOutlinedIcon : CancelIcon;

    return (
      <Card className={classes.variantviewfristcard}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: iconBg, color: iconColor }}>
            <Icon />
          </Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  type DetailRowProps = {
    label: string;
    value: React.ReactNode;
  };
  const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => (
    <Typography
      variant="subtitle1"
      sx={{
        display: "flex",
        borderBottom: "1px solid #e0e0e0",
        py: 0.8,
      }}
    >
      <Box
        component="span"
        sx={{
          width: "30%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {label}
      </Box>
      <Box
        component="span"
        sx={{
          width: "5%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {` : `}
      </Box>
      <Box
        component="span"
        sx={{
          width: "65%",
          pr: 1,
        }}
      >
        {value}
      </Box>
    </Typography>
  );

  if (isLoading || categoryLoading || productIsLoading || userIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <Card className={classes.stepperCard} sx={{ height: "100%" }}>
          <Grid container spacing={2} p={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"center"}
                spacing={2}
                sx={{ padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  display={isMobileRes ? "flex" : undefined}
                  alignContent={"center"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Box className={classes.productBox}>
                    {product?.mainItemImg || ReplaceImage ? (
                      <img
                        src={product?.mainItemImg || ReplaceImage}
                        alt="img"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                        onError={(e) => (e.currentTarget.src = ReplaceImage)}
                      />
                    ) : (
                      <IoIosImages style={{ fontSize: 60 }} />
                    )}
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="h4" textAlign={"center"}>
                    {toProperCase(product?.mainItemName)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ px: 2, pb: 3 }}
                className={classes.titleGrid}
              >
                <Grid item xs={12}>
                  <Stack spacing={2}>
                    <DetailRow
                      label="Name"
                      value={toProperCase(product?.mainItemName)}
                    />
                    {product?.categoryId && (
                      <DetailRow
                        label="Display Name"
                        value={categoryMap.get(product.categoryId) || ""}
                      />
                    )}

                    {product?.mainItemShortDescription && (
                      <DetailRow
                        label="Short Description"
                        value={product.mainItemShortDescription}
                      />
                    )}

                    {product?.mainItemLongDescription && (
                      <DetailRow
                        label="Long Description"
                        value={product.mainItemLongDescription}
                      />
                    )}
                    {product?.created_by && (
                      <DetailRow
                        label="Created by"
                        value={userMap.get(product.created_by)}
                      />
                    )}

                    {product?.created_at && (
                      <DetailRow
                        label="Created at"
                        value={dayjs(product.created_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}

                    {product?.updated_by && (
                      <DetailRow
                        label="Updated by"
                        value={userMap.get(product.updated_by)}
                      />
                    )}

                    {product?.updated_by && product?.updated_at && (
                      <DetailRow
                        label="Updated at"
                        value={dayjs(product.updated_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {product && (
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.editButtonList}
                          onClick={handleOpenEditTenant}
                        >
                          <EditSharpIcon className={classes.editListIcon} />
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.deleteButtonList}
                          onClick={() => handleOpenDeletePopupMI(product)}
                        >
                          <DeleteOutlineSharpIcon
                            className={classes.deleteListIcon}
                          />
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <Grid container spacing={4} p={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Active"
                  status={!!product?.isActive}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCardIcon
                  label={`Product (${countVariant.length || 0})`}
                  status={!!product?.isActive}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={12} xs={12}></Grid>
              <Grid item lg={3} md={6} sm={12} xs={12}></Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={1}
                sx={{
                  // borderBottom: 2,
                  padding: 2,
                }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <Typography
                    gutterBottom
                    className={classes.variantViewHedingeProg}
                  >
                    Variant
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12} sm={12} md={8} lg={8}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                      <TextField
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CiSearch className={classes.searchWidgetIcon} />
                            </InputAdornment>
                          ),
                          classes: {
                            root: classes.formControlList,
                          },
                        }}
                        fullWidth
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Name & Display Name.."
                        className={classes.searchTextField}
                        size="small"
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        // variant="contained"
                        className={classes.addNewButton}
                        onClick={handleAddProductClick}
                      >
                        Add Variant
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid>
                <TableContainer>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell
                          className={classes.tablheaderNoWidth}
                          sx={{ width: "5%" }}
                        >
                          <strong>#</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          sx={{ width: "60%" }}
                        >
                          <strong>Item</strong>
                        </TableCell>
                        {!isMobileRes && (
                          <TableCell
                            className={classes.tablheader}
                            sx={{ width: "5%" }}
                          >
                            <strong>Active</strong>
                          </TableCell>
                        )}
                        {!isMobileRes && (
                          <TableCell
                            className={classes.tablheader}
                            sx={{ width: "5%" }}
                          >
                            <strong>Sale</strong>
                          </TableCell>
                        )}
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Actions</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {productIsError || coursings.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            {productIsError
                              ? "Error fetching data"
                              : "No data available"}
                          </TableCell>
                        </TableRow>
                      ) : (
                        coursings
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row: IVariantView, index) => (
                            <TableRow
                              key={row.id}
                              className={classes.tableRowHover}
                            >
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                {index + 1}
                              </TableCell>

                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                <Link
                                  to={`/variant/view/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Grid
                                    container
                                    spacing={1}
                                    alignItems="center"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigate(`/variant/view/${row.id}`)
                                    }
                                  >
                                    <Grid item>
                                      <Box
                                        className={
                                          classes.SelectImageTableBoxwithBorder
                                        }
                                      >
                                        {row.variantImg || ReplaceImage ? (
                                          <img
                                            src={row.variantImg || ReplaceImage}
                                            alt="img"
                                            // alt={row.variantName.toLowerCase()}
                                            className={classes.SelectImageTable}
                                            onError={(e) =>
                                              (e.currentTarget.src =
                                                ReplaceImage)
                                            }
                                          />
                                        ) : (
                                          <IoIosImages
                                            className={classes.SelectImageTable}
                                          />
                                        )}
                                      </Box>
                                    </Grid>
                                    <Grid item xs>
                                      <Typography
                                        className={classes.nameTableList}
                                      >
                                        {toProperCase(row.variantName)}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Link>
                              </TableCell>
                              {!isMobileRes && (
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                  // sx={{ textAlign: "center" }}
                                >
                                  {row?.isActive == true ? (
                                    <DoneIcon
                                      className={classes.activeAvatar}
                                      sx={{
                                        fontSize: 36,
                                        borderRadius: "50%",
                                        p: "6px",
                                      }}
                                    />
                                  ) : (
                                    <CloseOutlinedIcon
                                      className={classes.inactiveAvatar}
                                      sx={{
                                        fontSize: 36,
                                        borderRadius: "50%",
                                        p: "6px",
                                      }}
                                    />
                                  )}
                                </TableCell>
                              )}
                              {!isMobileRes && (
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                  // sx={{ textAlign: "center" }}
                                >
                                  {row?.isOnSale == true ? (
                                    <DoneIcon
                                      className={classes.activeAvatar}
                                      sx={{
                                        fontSize: 36,
                                        borderRadius: "50%",
                                        p: "6px",
                                      }}
                                    />
                                  ) : (
                                    <CloseOutlinedIcon
                                      className={classes.inactiveAvatar}
                                      sx={{
                                        fontSize: 36,
                                        borderRadius: "50%",
                                        p: "6px",
                                      }}
                                    />
                                  )}
                                </TableCell>
                              )}
                              <TableCell className={classes.tablCell}>
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Grid item>
                                    <Link
                                      to={`/variant/view/${row.id}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Button
                                        className={classes.viewButtonList}
                                        onClick={() =>
                                          navigate(`/variant/view/${row.id}`)
                                        }
                                      >
                                        <VisibilitySharpIcon
                                          className={classes.viewListIcon}
                                        />
                                      </Button>
                                    </Link>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      className={classes.editButtonList}
                                      onClick={() => handleOpenDialog(row)}
                                    >
                                      <EditSharpIcon
                                        className={classes.editListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      className={classes.deleteButtonList}
                                      onClick={() => handleOpenDeletePopup(row)}
                                    >
                                      <DeleteOutlineSharpIcon
                                        className={classes.deleteListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </TableCell>
                            </TableRow>
                          ))
                      )}
                    </TableBody>
                  </Table>

                  <Grid
                    spacing={5}
                    p={"18px"}
                    py={4}
                    justifyContent={"end"}
                    container
                    textAlign={"center"}
                    alignContent={"center"}
                    alignItems={"center"}
                  >
                    <Grid
                      sx={{
                        textAlign: "end",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Pagination
                        count={coursings.length}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={handleChangePage}
                      />
                    </Grid>
                  </Grid>
                </TableContainer>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>

      {selectCustomer && (
        <NewPopupTenant
          openModel={openDialog}
          handleCloseDialog={handleCloseEditTenant}
          data={product ?? undefined}
        />
      )}
      {selectedProduct && (
        <NewPopUpProduct
          openModel={openDialogProduct}
          handleCloseDialog={handleCloseDialog}
          data={selectedProduct}
        />
      )}
      {productToDelete && (
        <DeletePopup
          open={openDeleteProduct}
          handleCloseDelete={handleCloseDeletePopup}
          onConfirm={async () => {
            await handleDelete(productToDelete.id.toString());
          }}
          title="Delete Product"
          content={`Are you sure you want to delete "${productToDelete.variantName}"?`}
        />
      )}
      {productToDeleteMI && (
        <DeletePopup
          open={openDeleteProductMI}
          handleCloseDelete={handleCloseDeletePopupMI}
          onConfirm={async () => {
            await handleDeleteMI(productToDeleteMI.id.toString());
          }}
          title="Delete Product"
          content={`Are you sure you want to delete "${productToDeleteMI.mainItemName}"?`}
        />
      )}

      <AlertPopUp
        open={deleteAlert}
        onCloseAlert={setDeleteAlert}
        message={alertMessage}
      />
    </Grid>
  );
};

export default Index;
